import { render } from "./GreenTick.vue?vue&type=template&id=32383dae"
import script from "./GreenTick.vue?vue&type=script&lang=js"
export * from "./GreenTick.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__